<template>
  <div :id="`${formName}-text-area-itn`">
    <validation-observer :ref="`${formName}-text-input-itn-observer`" v-slot="{ errors }">
      <b-overlay :show="disabled">
        <b-tabs :id="`${formName}-text-area-itn-tabs`" align="left">
          <template v-if="showLabel" #tabs-start>
            <li v-if="label" class="tabs-start nav-item align-self-end mr-2" role="presentation">
              <span class="label">{{ label }}</span>
            </li>
          </template>
          <b-tab
            v-for="lang in languages"
            :id="`${formName}-text-area-itn-tab-${lang.locale}`"
            :key="lang.locale"
            :active="lang.locale === localDefaultLang"
            class="tab"
            @click="focusOn(`${formName}-text-area-itn-area-${lang.locale}`)"
          >
            <template #title>
              <div class="title">
                <b-img :src="lang.img" class="img" />
                <span>{{ lang.locale }} </span>
                <span v-if="isRequired(lang.locale)" class="text-danger">&nbsp;* </span>
              </div>
            </template>
            <validation-provider :name="label" :rules="getRules(lang.locale)" :vid="`${formName}-text-area-itn-provider-${lang.locale}`">
              <b-form-group>
                <b-form-textarea
                  :id="`${formName}-text-area-itn-area-${lang.locale}`"
                  :ref="`${formName}-text-area-itn-area-${lang.locale}`"
                  :max-rows="maxRows"
                  :no-resize="noResize"
                  :placeholder="label"
                  :plaintext="plaintext"
                  :readonly="readonly"
                  :rows="rows"
                  :state="getFirstObserverError(errors) && false"
                  :value="value ? value[lang.locale] : ''"
                  class="form-area hide-scroll"
                  @input="value[lang.locale] = $event"
                />
                <small v-if="getFirstObserverError(errors) && !toolTipErrors" class="text-danger">
                  {{ getFirstObserverError(errors) }}
                </small>
                <b-tooltip
                  v-if="getFirstObserverError(errors) && toolTipErrors"
                  :target="`${formName}-text-area-itn-area-${lang.locale}`"
                  placement="bottom"
                  show
                  variant="light"
                >
                  <small class="text-danger">{{ getFirstObserverError(errors) }}</small>
                </b-tooltip>
              </b-form-group>
            </validation-provider>
          </b-tab>
          <template #empty>
            <div class="text-center text-muted">
              <b-form-textarea :id="`${formName}-text-area-itn-area-empty`" :placeholder="localNoLanguages" class="form-area" disabled />
            </div>
          </template>
        </b-tabs>
      </b-overlay>
    </validation-observer>
  </div>
</template>

<script>
export default {
  name: 'AppFormTextAreaItn',

  props: {
    formName: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    value: {
      type: Object,
      default: () => ({}),
    },
    languages: {
      type: Array,
      default: () => [],
    },
    defaultLang: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: String,
      default: '',
    },
    required: {
      type: Array,
      default: () => [],
    },
    noLanguages: {
      type: String,
      default: null,
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
    toolTipErrors: {
      type: Boolean,
      default: false,
    },
    rows: {
      type: Number,
      default: 2,
    },
    maxRows: {
      type: Number,
      default: 2,
    },
    plaintext: {
      type: Boolean,
      default: false,
    },
    noResize: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    localNoLanguages() {
      return this.noLanguages || this.$t('common.no_languages')
    },
    localDefaultLang() {
      return this.defaultLang || this.$store.state.auth.defaultLang
    },
  },

  mounted() {
    // Ajout de la langue de la plateforme en required par défaut
    this.required.push(localStorage.getItem('appLang'))
  },

  methods: {
    focusOn(ref) {
      this.$nextTick(() => {
        this.$refs[ref][0].focus()
      })
    },

    isRequired(lang) {
      return this.required.includes(lang)
    },

    getRules(lang) {
      const rules = this.required.includes(lang) ? ['required'] : []
      return rules.concat(this.rules).join('|')
    },

    getFirstObserverError(errors) {
      const errorsToArray = Object.entries(errors)
        .map(key => ({ [key[0]]: key[1] }))
        .filter(error => Object.values(error)[0].length > 0)

      if (errorsToArray.length) {
        return `${Object.keys(errorsToArray[0]).toString().slice(-2).toUpperCase()} : ${Object.values(errorsToArray[0])}`
      }

      return null
    },
  },
}
</script>

<style lang="scss" scoped>
.label {
  margin-bottom: 0.2857rem;
  display: block !important;
  color: #5e5873;
  font-size: 0.857rem;
}
.tab {
  margin-bottom: 0px;
}
.form-area {
  margin-top: -14px;
}
.title {
  margin-bottom: -3px;
}
.img {
  margin-right: 10px;
  height: 14px;
  width: 22px;
}
.hide-scroll::-webkit-scrollbar {
  display: none;
}
.tabs-start {
  min-width: 100px;
}

.dark-layout {
  .label {
    color: $theme-dark-body-color;
  }
}
</style>
